import Login from "../components/Welcome/Authentication/Login";

const HomePage = () => {
    return (
        <Login />
    );
};


export default HomePage;